import { useState } from "react";
import spinner from "../../assets/images/common/spinner.gif";
import muty_logo from "../../assets/images/common/muty_logo.png";
import { useMutation } from "@tanstack/react-query";
import { handleLogin } from "../../apis/auth";
import Cookies from "universal-cookie";
import { PROJECT_NAME, TOKEN_KEY } from "../../config";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { toast } from "react-hot-toast";

const cookies = new Cookies();

const Login = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  let token = sessionStorage.getItem(TOKEN_KEY);
  const initialData = {
    email: "",
    password: "",
  };

  const [userData, setuserData] = useState(initialData);
  const [error, setError] = useState("");
  const [recaptchaError, setRecaptchaError] = useState("");

  const handleChangeInput = (e) => {
    let value = e.target.value;
    let data = {
      ...userData,
      [e.target.name]: value,
    };
    setuserData(data);
  };

  const handleLoginUser = useMutation((data) => handleLogin(data), {
    onSuccess: (response) => {
      if (response.status === 200) {
        const accessToken = response?.data?.token;
        const roles = response?.data?.role;
        const email = response?.data?.email;
        // setAuth({email,roles,accessToken})
        sessionStorage.setItem(TOKEN_KEY, accessToken);
        sessionStorage.setItem("roles", roles);
        // window.location.replace("/")
        navigate(from, { replace: true });
        toast.success("Logged In Successfully", {
          position: "top-right",
          duration: 3000,
        });
      }
    },
    onError: (err) => {
      if (err.response.status === 400) {
        setError(err.response.data.message);
        toast.error("Oops! Something Went Wrong.", {
          position: "top-right",
          duration: 3000,
        });
        return;
      }
    },
  });

  const handleSubmitLoginForm = (e) => {
    e.preventDefault();
    handleLoginUser.mutate(userData);
  };

  if (token) return <Navigate to="/dashboard" replace />;

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen py-2 bg-gray-100">
        <div className="flex flex-col items-center justify-center w-full flex-1 px-10 lg:px-20 ">
          <div className="bg-white shadow-2xl flex flex-col-reverse lg:flex-row w-full lg:w-2/3 max-w-4xl">
            <div className="lg:w-3/5 py-10 lg:py-20 px-9">
              <p className=" text-3xl font-semibold mb-4 roboto">Login</p>
              <form
                className=" space-y-4"
                autoComplete="on"
                onSubmit={handleSubmitLoginForm}
              >
                <div>
                  <label htmlFor="email" className=" block text-xl roboto">
                    Email
                  </label>
                  <input
                    type="text"
                    required
                    className="border-solid border-2 border-gray-400 py-2 px-2 rounded w-full mt-2 placeholder:italic placeholder:text-sm"
                    name="email"
                    placeholder="Enter your email here"
                    value={userData.email}
                    onChange={handleChangeInput}
                  />
                </div>
                <div>
                  <label htmlFor="password" className=" block text-xl roboto">
                    Password
                  </label>
                  <input
                    autoComplete="off"
                    type="password"
                    required
                    className="border-solid border-2 border-gray-400 py-2 px-2 rounded w-full mt-2 placeholder:italic placeholder:text-sm"
                    name="password"
                    placeholder="Enter your password here"
                    value={userData.password}
                    onChange={handleChangeInput}
                  />
                </div>
                {error && (
                  <div className="text-red-700 text-center">
                    <small>{error}</small>
                  </div>
                )}
                {handleLoginUser.isLoading ? (
                  <div className=" w-8 h-8 mx-auto">
                    <img
                      src={spinner}
                      alt="spinner"
                      className="w-full h-full"
                    />
                  </div>
                ) : (
                  <div className="button">
                    <button className=" w-full py-2 bg-[color:var(--color1)] text-white rounded roboto font-semibold text-2xl">
                      Login
                    </button>
                  </div>
                )}
              </form>
            </div>
            <div className="lg:w-2/5 px-12 py-5 lg:py-0 text-center flex flex-col justify-center items-center bg-body_bg">
              <p className=" roboto font-semibold">
                Welcome To{" "}
                <span className="font-extrabold">{PROJECT_NAME}</span>
              </p>
              <div className="mt-8 w-60 relative left-2">
                <p className="font-semibold text-primary text-4xl ">
                  <img src={muty_logo} alt="" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
